export default __webpack_public_path__ + "static/media/v3.0.d6206f8b.svg";